module.exports = __webpack_public_path__ + "img/service-parts-display-parallax-black.7704f510.png";